<div>
    <div class='text-center'>
        <mat-icon [color]="msgType === 'success'?'warn':'primary'">{{msgType === 'warn'?'error':(msgType === 'success'?'success':'warn')}}</mat-icon>
    </div>
    <h5 class="text-center">{{msg}}</h5>
</div>
